import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=900fa572&scoped=true&lang=pug"
import script from "./Alert.js?vue&type=script&lang=js&external"
export * from "./Alert.js?vue&type=script&lang=js&external"
import style0 from "./Alert.vue?vue&type=style&index=0&id=900fa572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900fa572",
  null
  
)

export default component.exports